<template>
  <v-chip dark label small :color="color">{{ text }}</v-chip>
</template>

<script>
export default {
  props: {
    fueltype: [Number, String]
  },
  computed: {
    text () {
      const symbol = {
        0: '미지정',
        1: '경유',
        2: 'CNG',
        '미지정': '미지정',
        '경유': '경유',
        'CNG': 'CNG'
      }

      return symbol[this.fueltype]
    },
    color () {
      const symbol = {
        0: 'grey',
        1: 'light-green',
        2: 'light-blue',
        '미지정': 'grey',
        '경유': 'light-green',
        'CNG': 'light-blue'
      }

      return symbol[this.fueltype] || 'grey'
    }
  }
}
</script>
